import { formatifyHtml } from "./formatifyHtml.js";
import { thumbFromUrl } from "./thumbFromUrl.js";

function convertImagesToPicture(html: string, lightboxId = "content"): string {
	return html.replace(
		/<img(?<p1>[^>]+)src="(?<src>[^"]+)"(?<p2>[^>]*)>/gu,
		(_match, p1: string, src: string, p2: string) => {
			return `
				<picture class="js-picture">
					<source
						srcset="${thumbFromUrl(540, 0, src)} 1x"
						type="image/webp"
						media="(min-width: 577px)"
					/>
					<source
						srcset="${thumbFromUrl(530, 0, src)} 1x"
						type="image/webp"
						media="(max-width: 576px)"
					/>
					<a href="${thumbFromUrl(1440, 0, src)}" data-fslightbox="${lightboxId}" data-type="image">
						<img${p1}src="${thumbFromUrl(636, 0, src)}"${p2}>
					</a>
				</picture>
			`;
		},
	);
}

function fixYoutubeIframes(html: string): string {
	return html.replace(
		/<iframe(?<p1>[^>]+)src="https:[/][/]www[.]youtube[.]com[/]embed[/](?<v>[^"]+)"(?<p2>[^>]*)>/gu,
		(_match, p1: string, v: string, p2: string) =>
			`<iframe ${p1} title="YouTube video" src="https://www.youtube.com/embed/${v}" referrerpolicy="strict-origin-when-cross-origin" ${p2}>`,
	);
}

function createOverflowTable(html: string): string {
	return html.replace(/<table[^>]*>(?<content>.*?)<\/table>/gsu, (_match, content: string) => {
		return `
			<div class="responsive-table">
				<table>${content}</table>
			</div>
		`;
	});
}

export function transformCkEditorContent(html: string, lightboxId?: string): string {
	const withConvertedImages = convertImagesToPicture(html, lightboxId);
	const withFixedYoutubeIframes = fixYoutubeIframes(withConvertedImages);
	const withOverflowedTables = createOverflowTable(withFixedYoutubeIframes);
	const htmlElement = document.createElement("div");
	htmlElement.innerHTML = withOverflowedTables;
	return formatifyHtml(htmlElement);
}
